import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import {
  filterCriteriaSF,
  getSpecificSearchPatterMatch,
  tableSearchAF,
} from "@ryde/shared";

import { usePageContext } from "../../contexts";

export const useFiltersActiveState = () => {
  const { entity } = usePageContext();
  const searchText = useRecoilValue(tableSearchAF(entity));
  const filtersCriteriaObj = useRecoilValue(filterCriteriaSF(entity));
  const isSearchText = getSpecificSearchPatterMatch(searchText)?.[1] ?? "";

  const isAnyFilterActive = useMemo(
    () =>
      (filtersCriteriaObj !== undefined &&
        Boolean(Object.keys(filtersCriteriaObj).length)) ||
      Boolean(isSearchText),
    [filtersCriteriaObj, isSearchText],
  );
  return { isAnyFilterActive };
};
